import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import ReactInputRange from "react-input-range";

const InputRange = ReactInputRange;

const styles = (theme) => {
	return {
		root: {
			width: "100%",
		},
		header: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: 1,
			letterSpacing: "2.3px",
			color: theme.palette.colors.darkSlateBlue,
			textTransform: "uppercase",
			marginBottom: "17px",
		},
		wrapper: {
			position: "relative",
			"& $bodyWrapperNotEmpty": {
				border: `1px solid ${theme.palette.colors.purplishBlue}`,
				"& $inputPlaceholder": {
					"& span": {
						color: theme.palette.colors.purplishBlue,
					},
				},
				"& $arrow": {
					"& span": {
						color: theme.palette.colors.purplishBlue,
					},
				},
				"& $svg": {
					color: theme.palette.colors.purplishBlue,
				},
			},
		},
		bodyWrapper: {
			position: "relative",
			top: 0,
			left: 0,
			maxHeight: "50px",
			overflow: "hidden",
			borderRadius: "10px",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			backgroundColor: "rgba(255,255,255, .5)",
		},
		body: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "center",
			padding: "0 22px",
			boxSizing: "border-box",
			cursor: "pointer",
		},
		whiteBody: {
			backgroundColor: "#ffffff",
		},
		inputWrapper: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			width: "100%",
			boxSizing: "border-box",
		},
		input: {
			display: "none",
			border: "none",
			width: "100%",
			padding: "15px 0 17px",
			color: theme.palette.colors.purplishBlue,
			backgroundColor: theme.palette.colors.white,
			userSelect: "none",
		},
		inputLast: {
			textAlign: "right",
		},
		inputPlaceholder: {
			padding: "15px 0 17px",
			"& span": {
				fontFamily: theme.fonts.light,
				fontSize: "16px",
				lineHeight: 1,
				color: theme.palette.colors.oneMoreGrey,
			},
		},
		arrow: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			width: "24px",
			"& span": {
				color: theme.palette.colors.lightGrayishViolet,
				fontSize: "24px",
				transform: "rotate(-90deg)",
			},
		},
		picker: {
			display: "none",
			margin: "15px 0 20px",
			width: "100%",
			"& .input-range__track--background": {
				backgroundColor: theme.palette.colors.lightGrayishViolet,
			},
			"& .input-range__track": {
				height: "1px",
				position: "relative",
			},
			"& .input-range__track--active": {
				backgroundColor: theme.palette.colors.purplishBlue,
			},
			"& .input-range__label": {
				display: "none",
			},
			"& .input-range__slider": {
				width: "20px",
				height: "20px",
				backgroundColor: theme.palette.colors.white,
				boxShadow: "0 2px 3px 0 rgba(0, 0, 0, 0.1)",
				border: `solid 1px ${theme.palette.colors.purplishBlue}`,
				borderRadius: "50%",
				position: "absolute",
				left: "-9px",
				top: "-10px",
			},
		},
		labelsList: {
			display: "flex",
			width: "100%",
			justifyContent: "space-between",
			alignItems: "flex-start",
			marginBottom: "17px",
		},
		labelsItem: {
			fontFamily: theme.fonts.medium,
			fontSize: "12px",
			lineHeight: "1.33",
			color: theme.palette.colors.purplishBlue,
		},
		wrapperIsOpen: {
			height: "50px",
			"& $bodyWrapper": {
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				backgroundColor: theme.palette.colors.white,
				boxShadow: "0 2px 20px 0 rgba(0, 0, 0, 0.1)",
				transition: "background-color, max-height 0.3s ease",
				transform: "translate3d(0,0,0)",
				zIndex: "5",
				border: `solid 1px ${theme.palette.colors.purplishBlue}`,
			},
			"& $arrow": {
				"& span": {
					color: theme.palette.colors.purplishBlue,
				},
			},
			"& $svg": {
				color: theme.palette.colors.purplishBlue,
			},
			"& $body": {
				alignItems: "flex-start",
			},
			"& $input": {
				display: "block",
			},
			"& $inputPlaceholder": {
				display: "none",
			},
			"& $picker": {
				display: "block",
			},
			"& $labelsList": {
				display: "flex",
			},
		},
		bodyWrapperNotEmpty: {},
		rootError: {
			"& $bodyWrapper": {
				border: `solid 1px ${theme.palette.colors.coralPink}`,
			},
			"& $wrapperIsOpen": {
				"& $bodyWrapper": {
					border: `solid 1px ${theme.palette.colors.purplishBlue}`,
				},
			},
		},
		svg: {
			color: theme.palette.colors.lightGrayishViolet,
			fontSize: "20px",
			marginLeft: "20px",
			cursor: "pointer",
			position: "relative",
			top: "-1px",
			left: "1px",
		},

		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			header: {
				fontSize: "13px",
				lineHeight: "1.14",
				letterSpacing: "2px",
			},
			inputPlaceholder: {
				"& span:first-child": {
					display: "none",
				},
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			header: {
				fontSize: "13px",
				lineHeight: "1.14",
				letterSpacing: "2px",
				marginBottom: "12px",
			},
			picker: {
				marginTop: "25px",
				"& .input-range__slider": {
					position: "relative",
					"&:before": {
						position: "absolute",
						content: '""',
						width: "35px",
						height: "35px",
						top: "-50%",
						left: "-50%",
						backgroundColor: theme.palette.colors.transparent,
						cursor: "pointer",
					},
				},
			},
			svg: {
				fontSize: "20px",
				left: "3px",
			},
		},
	};
};

class RangePicker extends React.Component {
	static defaultProps = {
		textMainInput: () => {},
		changeFilter: () => {},
		range: {
			min: 0,
			max: 1000,
		},
		freq: 10000,
		disabledArrowCount: 10000,
		lengthRange: 10000,
		requireUpdate: false,
		rangeUpdate: {},
		datatest: null,
	};

	constructor(props) {
		super(props);
		this.state = {
			value: this.normalizeValue(),
			outerValue: this.normalizeValue(),
			isOpen: false,
		};
	}

	bodyWrapper = null;
	body = null;
	filterWrapper = null;

	normalizeValue() {
		if (!this.props.value) {
			return this.props.range;
		}
		return this.props.value;
	}

	bindedCloseFunction = (e) => {
		this.handleClickOutside(e);
	};

	componentDidMount() {
		this.props.onMount && this.props.onMount(this);
	}

	openFilter() {
		if (!this.state.initMaxHeight) {
			this.setState({
				...this.state,
				initMaxHeight: this.bodyWrapper.offsetHeight + "px",
				maxHeight: this.body.offsetHeight + "px",
			});
		}
		let fromTop = false;
		let bodyWrapperCoords = this.bodyWrapper.getBoundingClientRect();
		let toBottomLength = window.innerHeight - bodyWrapperCoords.bottom;
		if (toBottomLength + 20 < this.body.offsetHeight) {
			fromTop = true;
		}

		this.setState(
			(state) => {
				if (!state.isOpen) {
					this.props.onFocus?.();
				}

				return {
					isOpen: true,
				};
			},
			() => {
				this.bodyWrapper.style.maxHeight = this.body.offsetHeight + "px";
				if (fromTop) {
					this.bodyWrapper.style.bottom = "0";
					this.bodyWrapper.style.top = "initial";
				}
			}
		);

		document.addEventListener("click", this.bindedCloseFunction);
	}

	closeFilter() {
		this.bodyWrapper.style.maxHeight = this.state.initMaxHeight;
		this.bodyWrapper.style.top = null;
		this.bodyWrapper.style.bottom = null;
		document.removeEventListener("click", this.bindedCloseFunction);
		this.props.changeFilter(this.props.type, this.state.value);

		this.setState({
			isOpen: false,
		});

		this.props.onBlur?.();
	}

	resetIconClick() {
		this.bodyWrapper.style.maxHeight = this.state.initMaxHeight;
		this.bodyWrapper.style.top = null;
		this.bodyWrapper.style.bottom = null;
		document.removeEventListener("click", this.bindedCloseFunction);

		this.setState({
			isOpen: false,
		});

		this.props.onBlur?.();
	}

	handleClickOutside(event) {
		if (this.filterWrapper != null) {
			if (!this.filterWrapper.contains(event.target)) {
				this.closeFilter();
			}
		}
	}

	changeSliderValue() {
		let nowValue = {
			min: this.state.value.min,
			max: this.state.value.max,
		};

		this.setState({
			value: nowValue,
		});
	}

	generatePointList() {
		let range = this.props.range;
		let middlePoint = (range.max - range.min) / 2;
		if (middlePoint == 0) {
			return [range.min];
		}
		return [range.min, Math.round(range.min + middlePoint), range.max];
	}

	moveSlider(value) {
		let newValue = {
			min: value.min < this.props.range.min ? this.props.range.min : value.min,
			max: value.max > this.props.range.max ? this.props.range.max : value.max,
		};
		this.setState({
			value: newValue,
		});
	}

	static getDerivedStateFromProps(props, state) {
		if (!state.isOpen) {
			if (props.value != state.outerValue || !props.value) {
				let newValue = !!props.value ? props.value : props.range;
				return {
					...state,
					value: newValue,
					outerValue: newValue,
				};
			}
		}

		return state;
	}

	render() {
		let classes = this.props.classes;
		let text = this.props.text;
		let isSelected =
			this.props.range.min != this.state.value.min || this.props.range.max != this.state.value.max;
		return (
			<div
				className={classNames(classes.root, {
					[classes.rootError]: this.props.error,
				})}
			>
				<div className={classes.header}>{this.props.title}</div>
				<div
					className={classNames(classes.wrapper, {
						[classes.wrapperIsOpen]: this.state.isOpen,
					})}
					onClick={(e) => this.openFilter(e)}
					ref={(wrapper) => {
						this.filterWrapper = wrapper;
					}}
					tabIndex={-1}
				>
					<div
						className={classNames(classes.bodyWrapper, {
							[classes.bodyWrapperNotEmpty]: isSelected,
						})}
						ref={(wrapper) => (this.bodyWrapper = wrapper)}
					>
						{/*
                            // @ts-ignore */}
						<div
							className={classNames(classes.body, {
								[classes.whiteBody]: this.props.whiteBody,
							})}
							ref={(body) => (this.body = body)}
							datatest={this.props.datatest}
						>
							<div className={classes.inputWrapper}>
								<input
									type="number"
									disabled={true}
									className={classes.input}
									placeholder={`${text.FROM} ${this.state.value.min}`}
									value={this.state.value.min}
									name={this.props.inputNameMin}
								/>
								<div className={classes.inputPlaceholder}>
									<span> {text.FROM} </span>
									<span>{this.state.value.min}</span>
								</div>

								<div className={classes.arrow}>
									<span className="icon32 icon-arrow-2-down" />
								</div>
								<input
									type="number"
									disabled={true}
									className={classNames(classes.input, classes.inputLast)}
									placeholder={`${text.TO} ${this.state.value.max}`}
									value={this.state.value.max}
									name={this.props.inputNameMax}
								/>
								<div className={classes.inputPlaceholder}>
									<span>{text.TO} </span>
									<span>{this.state.value.max}</span>
								</div>
								{this.props.onReset && isSelected && (
									<span
										className={classNames("icon-close", "icon24", classes.svg)}
										onClick={(e) => {
											this.props.onReset();
											this.resetIconClick();
											e.stopPropagation();
										}}
									/>
								)}
							</div>

							<div className={classes.picker}>
								<InputRange
									allowSameValues={true}
									disabled={this.props.range.min == this.props.range.max}
									minValue={this.props.range.min}
									maxValue={this.props.range.max}
									value={this.state.value}
									onChangeComplete={() => this.changeSliderValue()}
									onChange={(value) => this.moveSlider(value)}
									step={this.props.step}
								/>
							</div>
							<div className={classes.labelsList}>
								{this.generatePointList().map((point, key) => (
									<span key={key} className={classes.labelsItem}>
										{point}
									</span>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(RangePicker);

export { RangePicker as __RangePicker };
